import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import MainLayout from './layout/Main';
import PageComponents from './pages';
import PageMeta from './partials/PageMeta';
import ErrorPage from './pages/Error';

import { loadPage } from '../lib/requests';

import { setPage as setPageAction } from '../actions/SiteActions';

import '../../styles/main.global.scss';

const propTypes = {
    pages: PropTypes.object.isRequired, // eslint-disable-line
    location: PropTypes.object.isRequired, // eslint-disable-line
    setPage: PropTypes.func.isRequired,
};

const defaultProps = {};

const Page = ({ pages, location, setPage }) => {
    const pageUrl = location.pathname;

    const page = pages[pageUrl] || {};
    const [currentPage, setCurrentPage] = useState(page);

    // useEffect(() => {
    //     let timeout = null;
    //     if (page.id && page.url !== currentPage.url) {
    //         clearTimeout(timeout);
    //         timeout = setTimeout(() => {
    //             setCurrentPage(page);
    //         }, 0);
    //     }
    //     return () => {
    //         clearTimeout(timeout);
    //     };
    // }, [page, currentPage]);

    useEffect(() => {
        const url = pageUrl === '/' ? '/home' : pageUrl;
        loadPage(url.replace(/(\.json|\/)?$/, '.json'))
            .then((r) => {
                setPage(pageUrl, r);
                setCurrentPage(r);
            })
            .catch((e) => {
                console.log('error', e); // eslint-disable-line
            });
    }, [pageUrl]);

    let Component = null;
    if (currentPage) {
        const { pageType, handle } = currentPage;
        if (handle && PageComponents[handle]) {
            Component = PageComponents[handle];
        } else if (pageType && PageComponents[pageType]) {
            Component = PageComponents[pageType];
        }
    }

    return (
        <MainLayout
            page={currentPage || null}
            // transitionTheme={page.theme ? page.theme : null}
            inTransition={page.id !== currentPage.id}
        >
            <PageMeta page={page} />
            {Component !== null && currentPage.id ? (
                <Component url={pageUrl} page={currentPage} />
            ) : (
                <ErrorPage statusCode={404} />
            )}
        </MainLayout>
    );
};

Page.propTypes = propTypes;
Page.defaultProps = defaultProps;

const WithStateContainer = connect(
    ({ site }) => ({
        pages: site.pages,
    }),
    (dispatch) => ({
        setPage: (url, page) => dispatch(setPageAction(url, page)),
    }),
)(Page);
export default WithStateContainer;
